export default {
    props: {
        excludeHeaders: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        processedHeaders () {
            return this.headers?.filter(header => {
                return !this.excludeHeaders?.some(exclHeader => exclHeader === header.value)
            })
        }
    }
}
